"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WalletBlock = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _BlockType = require("../BlockType");
var _variables = require("@blockwell/variables");
const settings = [{
  title: "Wallet",
  settings: {
    defaultWallet: {
      type: "select",
      enum: ["", "wallet", "metamask"],
      title: "Default Wallet Type",
      description: "You can override which type of wallet will be shown by default."
    }
  }
}, {
  title: "Wallet Variable",
  settings: {
    variable: {
      type: "def",
      description: "The wallet will be made available as this variable.",
      default: {
        name: "wallet"
      }
    }
  }
}];
class WalletBlock extends _BlockType.BlockType {
  constructor(param, variableTypes) {
    super();
    (0, _defineProperty2.default)(this, "type", "wallet");
    (0, _defineProperty2.default)(this, "noChildren", true);
    (0, _defineProperty2.default)(this, "wallet", void 0);
    (0, _defineProperty2.default)(this, "defaultWallet", void 0);
    this.param = param;
    this.wallet = this.addBlockVariablePair(new _variables.WalletVariable(), param, ["variable"], {
      key: "variable",
      default: "wallet"
    });
    this.defaultWallet = this.addBlockVariablePair(variableTypes.get("literal"), param, [["defaultWallet", "value"]]);
  }
  renderValue() {
    return {
      wallet: _variables.vals.address(this.wallet.ref.value()),
      defaultWallet: _variables.vals.stringValue(this.defaultWallet.ref.value())
    };
  }
}
exports.WalletBlock = WalletBlock;
(0, _defineProperty2.default)(WalletBlock, "settings", settings);
//# sourceMappingURL=WalletBlock.js.map